import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { Configurations } from '../Configuration';

import { SerengetiCommonUIModule } from '../modules/common.ui.module';
import { MaterialModule } from '../modules/material.module';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './common/home/home.component';
import { ClipboardModalComponent } from './console/clipboard/clipboardmodal.component';
import { RemoteConsoleComponent } from './console/console.component';
import { DisplayComponent } from './console/ngx-remote-desktop/components/display.component';
import { MessageComponent } from './console/ngx-remote-desktop/components/message.component';
import { ConnectingMessageComponent } from './console/ngx-remote-desktop/components/messages/connecting-message.component';
import { DisconnectedMessageComponent } from './console/ngx-remote-desktop/components/messages/disconnected-message.component';
import { ErrorMessageComponent } from './console/ngx-remote-desktop/components/messages/error-message.component';
import { RemoteDesktopComponent } from './console/ngx-remote-desktop/components/remote-desktop.component';
import { StatusBarItemComponent } from './console/ngx-remote-desktop/components/status-bar-item.component';
import { StatusBarComponent } from './console/ngx-remote-desktop/components/status-bar.component';
import { ToolbarItemComponent } from './console/ngx-remote-desktop/components/toolbar-item.component';

import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';
import {environment} from '../environments/environment';

export function getProduction(): boolean {
  if (SerengetiRemoteConsoleModule.environment && SerengetiRemoteConsoleModule.environment.createTranslateLoader) {
    return true;
  } else {
    return environment.production;
  }
}

export function getLoginEndPoint() {
  if (SerengetiRemoteConsoleModule.environment && SerengetiRemoteConsoleModule.environment.createTranslateLoader) {
    return SerengetiRemoteConsoleModule.environment.getLoginEndPoint();
  } else {
    return Configurations.serviceLoginCoreEndPoint;
  }
}

export function createTranslateLoader(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: 'assets/i18n/common/', suffix: '.json' },
    { prefix: 'assets/i18n/console/', suffix: '.json' },
  ]);
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,

    ConnectingMessageComponent,
    DisconnectedMessageComponent,
    ErrorMessageComponent,

    RemoteDesktopComponent,
    DisplayComponent,
    ToolbarItemComponent,
    StatusBarComponent,
    StatusBarItemComponent,
    MessageComponent,

    RemoteConsoleComponent,
    ClipboardModalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
		MaterialModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    SerengetiCommonUIModule,
  ],
  providers: [
    TranslateService,
    Configurations,
  ],
  exports: [
    RemoteConsoleComponent,
    ClipboardModalComponent,
  ],
  bootstrap: [
    AppComponent,
  ],
})
export class SerengetiRemoteConsoleModule {
  public static environment: Configurations = null;

  constructor(translate: TranslateService, config: Configurations) {
    translate.setDefaultLang('ko-kr');
    translate.use('ko-kr');

    SerengetiRemoteConsoleModule.environment = config;
  }

  public static forRoot(environment: Configurations): ModuleWithProviders<any> {
    return {
        ngModule: SerengetiRemoteConsoleModule,
        providers: [
          { provide: Configurations, useValue: environment },
        ],
    };
  }
}
